var map = {
	"./accountancy/img1.png": 82292,
	"./accountancy/img10.png": 44174,
	"./accountancy/img11.png": 43671,
	"./accountancy/img12.png": 36092,
	"./accountancy/img13.png": 72005,
	"./accountancy/img14.png": 1578,
	"./accountancy/img15.png": 33491,
	"./accountancy/img2.png": 3759,
	"./accountancy/img3.png": 22214,
	"./accountancy/img4.png": 24633,
	"./accountancy/img5.png": 18384,
	"./accountancy/img6.png": 48555,
	"./accountancy/img7.png": 58050,
	"./accountancy/img8.png": 63077,
	"./accountancy/img9.png": 27164,
	"./biology/img1.png": 66391,
	"./biology/img10.png": 12887,
	"./biology/img11.png": 39246,
	"./biology/img12.png": 41669,
	"./biology/img13.png": 24156,
	"./biology/img14.png": 24115,
	"./biology/img15.png": 73354,
	"./biology/img16.png": 22337,
	"./biology/img2.png": 36431,
	"./biology/img3.png": 94725,
	"./biology/img4.png": 24298,
	"./biology/img5.png": 56211,
	"./biology/img6.png": 60600,
	"./biology/img7.png": 81729,
	"./biology/img8.png": 53862,
	"./biology/img9.png": 35407,
	"./businessstudies/img1.png": 40259,
	"./businessstudies/img10.png": 11339,
	"./businessstudies/img11.png": 47682,
	"./businessstudies/img12.png": 61689,
	"./businessstudies/img13.png": 29584,
	"./businessstudies/img2.png": 3400,
	"./businessstudies/img3.png": 97265,
	"./businessstudies/img4.png": 30526,
	"./businessstudies/img5.png": 83015,
	"./businessstudies/img6.png": 64012,
	"./businessstudies/img7.png": 16277,
	"./businessstudies/img8.png": 29074,
	"./businessstudies/img9.png": 60251,
	"./chemistry/img1.png": 61582,
	"./chemistry/img10.png": 39564,
	"./chemistry/img11.png": 6101,
	"./chemistry/img12.png": 20350,
	"./chemistry/img13.png": 8039,
	"./chemistry/img14.png": 16520,
	"./chemistry/img15.png": 72817,
	"./chemistry/img16.png": 48154,
	"./chemistry/img2.png": 31941,
	"./chemistry/img3.png": 49052,
	"./chemistry/img4.png": 3923,
	"./chemistry/img5.png": 48714,
	"./chemistry/img6.png": 79297,
	"./chemistry/img7.png": 35787,
	"./chemistry/img8.png": 83119,
	"./chemistry/img9.png": 44102,
	"./economics/indianeconomics/img1.png": 40490,
	"./economics/indianeconomics/img2.png": 81569,
	"./economics/indianeconomics/img3.png": 60440,
	"./economics/indianeconomics/img4.png": 82583,
	"./economics/indianeconomics/img5.png": 83086,
	"./economics/indianeconomics/img6.png": 10917,
	"./economics/indianeconomics/img7.png": 58652,
	"./economics/indianeconomics/img8.png": 80043,
	"./economics/macroeconomics/img1.png": 52713,
	"./economics/macroeconomics/img2.png": 87570,
	"./economics/macroeconomics/img3.png": 36571,
	"./economics/macroeconomics/img4.png": 42980,
	"./economics/macroeconomics/img5.png": 69133,
	"./economics/microeconomics/img.png": 70818,
	"./economics/microeconomics/img1.png": 19201,
	"./economics/microeconomics/img2.png": 61770,
	"./economics/microeconomics/img3.png": 93683,
	"./economics/microeconomics/img4.png": 96284,
	"./economics/microeconomics/img5.png": 32197,
	"./generalenglish/img1.png": 53916,
	"./generalenglish/img10.png": 1350,
	"./generalenglish/img11.png": 82895,
	"./generalenglish/img12.png": 61428,
	"./generalenglish/img14.png": 37186,
	"./generalenglish/img15.png": 27691,
	"./generalenglish/img2.png": 42647,
	"./generalenglish/img3.png": 52654,
	"./generalenglish/img4.png": 35745,
	"./generalenglish/img5.png": 63032,
	"./generalenglish/img6.png": 37523,
	"./generalenglish/img7.png": 86762,
	"./generalenglish/img8.png": 63357,
	"./generalenglish/img9.png": 42228,
	"./generaltest/generalawareness/img1.png": 81832,
	"./generaltest/generalawareness/img10.png": 16538,
	"./generaltest/generalawareness/img11.png": 34115,
	"./generaltest/generalawareness/img12.png": 48840,
	"./generaltest/generalawareness/img13.png": 46705,
	"./generaltest/generalawareness/img14.png": 5694,
	"./generaltest/generalawareness/img15.png": 24007,
	"./generaltest/generalawareness/img2.png": 18691,
	"./generaltest/generalawareness/img3.png": 70938,
	"./generaltest/generalawareness/img4.png": 94709,
	"./generaltest/generalawareness/img5.png": 58796,
	"./generaltest/generalawareness/img6.png": 61447,
	"./generaltest/generalawareness/img7.png": 8958,
	"./generaltest/generalawareness/img8.png": 38473,
	"./generaltest/generalawareness/img9.png": 60352,
	"./generaltest/logicalreasoning/img1.png": 91440,
	"./generaltest/logicalreasoning/img10.png": 40082,
	"./generaltest/logicalreasoning/img11.png": 89083,
	"./generaltest/logicalreasoning/img12.png": 50400,
	"./generaltest/logicalreasoning/img13.png": 5225,
	"./generaltest/logicalreasoning/img14.png": 30966,
	"./generaltest/logicalreasoning/img15.png": 9055,
	"./generaltest/logicalreasoning/img2.png": 56843,
	"./generaltest/logicalreasoning/img3.png": 93186,
	"./generaltest/logicalreasoning/img4.png": 85981,
	"./generaltest/logicalreasoning/img5.png": 64852,
	"./generaltest/logicalreasoning/img6.png": 87311,
	"./generaltest/logicalreasoning/img7.png": 2214,
	"./generaltest/logicalreasoning/img8.png": 58369,
	"./generaltest/logicalreasoning/img9.png": 85656,
	"./generaltest/mathematics/img1.png": 52497,
	"./generaltest/mathematics/img10.png": 14821,
	"./generaltest/mathematics/img11.png": 85404,
	"./generaltest/mathematics/img12.png": 86039,
	"./generaltest/mathematics/img13.png": 43022,
	"./generaltest/mathematics/img14.png": 79137,
	"./generaltest/mathematics/img15.png": 10872,
	"./generaltest/mathematics/img16.png": 85363,
	"./generaltest/mathematics/img2.png": 22330,
	"./generaltest/mathematics/img3.png": 39907,
	"./generaltest/mathematics/img4.png": 9740,
	"./generaltest/mathematics/img5.png": 78837,
	"./generaltest/mathematics/img6.png": 11486,
	"./generaltest/mathematics/img7.png": 29799,
	"./generaltest/mathematics/img8.png": 85568,
	"./generaltest/mathematics/img9.png": 40393,
	"./geography/fundamentalsofhumangeography/img1.png": 72667,
	"./geography/fundamentalsofhumangeography/img10.png": 76275,
	"./geography/fundamentalsofhumangeography/img2.png": 94336,
	"./geography/fundamentalsofhumangeography/img3.png": 65513,
	"./geography/fundamentalsofhumangeography/img4.png": 49334,
	"./geography/fundamentalsofhumangeography/img5.png": 45663,
	"./geography/fundamentalsofhumangeography/img6.png": 91012,
	"./geography/fundamentalsofhumangeography/img7.png": 30957,
	"./geography/fundamentalsofhumangeography/img8.png": 47450,
	"./geography/fundamentalsofhumangeography/img9.png": 48675,
	"./geography/india:peopleandeconomy/img1.png": 42816,
	"./geography/india:peopleandeconomy/img10.png": 79106,
	"./geography/india:peopleandeconomy/img2.png": 21147,
	"./geography/india:peopleandeconomy/img3.png": 6322,
	"./geography/india:peopleandeconomy/img4.png": 11181,
	"./geography/india:peopleandeconomy/img5.png": 57284,
	"./geography/india:peopleandeconomy/img6.png": 94143,
	"./geography/india:peopleandeconomy/img7.png": 97206,
	"./geography/india:peopleandeconomy/img8.png": 74513,
	"./geography/india:peopleandeconomy/img9.png": 64296,
	"./history/img1.png": 58228,
	"./history/img10.png": 86926,
	"./history/img11.png": 29943,
	"./history/img12.png": 29308,
	"./history/img13.png": 58725,
	"./history/img14.png": 74058,
	"./history/img15.png": 29267,
	"./history/img16.png": 38424,
	"./history/img2.png": 93487,
	"./history/img3.png": 54470,
	"./history/img4.png": 47545,
	"./history/img5.png": 50640,
	"./history/img6.png": 20491,
	"./history/img7.png": 83010,
	"./history/img8.png": 29957,
	"./history/img9.png": 16892,
	"./mathematics/img1.png": 57002,
	"./mathematics/img10.png": 38928,
	"./mathematics/img11.png": 45177,
	"./mathematics/img12.png": 78594,
	"./mathematics/img13.png": 69099,
	"./mathematics/img14.png": 2836,
	"./mathematics/img15.png": 40317,
	"./mathematics/img16.png": 42758,
	"./mathematics/img2.png": 87585,
	"./mathematics/img3.png": 66456,
	"./mathematics/img4.png": 99095,
	"./mathematics/img5.png": 69870,
	"./mathematics/img6.png": 23877,
	"./mathematics/img7.png": 40988,
	"./mathematics/img8.png": 66827,
	"./mathematics/img9.png": 45698,
	"./physicaleducation/img1.png": 17397,
	"./physicaleducation/img10.png": 79473,
	"./physicaleducation/img2.png": 31646,
	"./physicaleducation/img3.png": 84135,
	"./physicaleducation/img4.png": 4520,
	"./physicaleducation/img5.png": 98385,
	"./physicaleducation/img6.png": 93626,
	"./physicaleducation/img7.png": 41379,
	"./physicaleducation/img8.png": 97508,
	"./physicaleducation/img9.png": 51405,
	"./physics/img1.png": 77609,
	"./physics/img10.png": 20173,
	"./physics/img11.png": 94020,
	"./physics/img12.png": 7583,
	"./physics/img13.png": 29494,
	"./physics/img14.png": 3753,
	"./physics/img15.png": 48928,
	"./physics/img2.png": 12466,
	"./physics/img3.png": 61467,
	"./physics/img4.png": 51524,
	"./physics/img5.png": 94029,
	"./physics/img6.png": 3350,
	"./physics/img7.png": 81439,
	"./physics/img8.png": 74888,
	"./physics/img9.png": 14833,
	"./politicalscience/img1.png": 67407,
	"./politicalscience/img10.png": 32031,
	"./politicalscience/img11.png": 53942,
	"./politicalscience/img12.png": 44621,
	"./politicalscience/img13.png": 2116,
	"./politicalscience/img14.png": 12059,
	"./politicalscience/img15.png": 63058,
	"./politicalscience/img16.png": 28201,
	"./politicalscience/img17.png": 57024,
	"./politicalscience/img18.png": 647,
	"./politicalscience/img2.png": 28596,
	"./politicalscience/img3.png": 66077,
	"./politicalscience/img4.png": 56930,
	"./politicalscience/img5.png": 20587,
	"./politicalscience/img6.png": 55184,
	"./politicalscience/img7.png": 70937,
	"./politicalscience/img8.png": 55374,
	"./politicalscience/img9.png": 29015,
	"./psychology/img1.png": 81113,
	"./psychology/img10.png": 98365,
	"./psychology/img11.png": 77236,
	"./psychology/img12.png": 98703,
	"./psychology/img14.png": 19577,
	"./psychology/img15.png": 13328,
	"./psychology/img2.png": 25026,
	"./psychology/img3.png": 46155,
	"./psychology/img4.png": 96244,
	"./psychology/img5.png": 29277,
	"./psychology/img6.png": 31718,
	"./psychology/img7.png": 70735,
	"./psychology/img8.png": 45784,
	"./psychology/img9.png": 66913,
	"./sociology/img1.png": 47618,
	"./sociology/img10.png": 75992,
	"./sociology/img11.png": 48705,
	"./sociology/img12.png": 99722,
	"./sociology/img13.png": 50483,
	"./sociology/img14.png": 50524,
	"./sociology/img15.png": 84389,
	"./sociology/img16.png": 65614,
	"./sociology/img17.png": 55607,
	"./sociology/img18.png": 65424,
	"./sociology/img2.png": 3705,
	"./sociology/img3.png": 97456,
	"./sociology/img4.png": 9679,
	"./sociology/img5.png": 70662,
	"./sociology/img6.png": 51869,
	"./sociology/img7.png": 18836,
	"./sociology/img8.png": 30483,
	"./sociology/img9.png": 75274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8758;